"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _mobx = require("mobx");
var _throttleDebounce = require("throttle-debounce");
var _dom = _interopRequireDefault(require("@myalbum/dom"));
var _resizeObserver = require("resize-observer");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
var isServerSide = typeof window === 'undefined';
var __DEV__ = process.env.NODE_ENV && process.env.NODE_ENV === "development";
function getDocumentOffsetPosition(el) {
    var position = {
        top: el === window ? 0 : el.offsetTop,
        left: el === window ? 0 : el.offsetLeft
    };
    if (el.offsetParent) {
        var parentPosition = getDocumentOffsetPosition(el.offsetParent);
        position.top += parentPosition.top;
        position.left += parentPosition.left;
    }
    return position;
}
var LazyStore = /*#__PURE__*/ function() {
    "use strict";
    function LazyStore(config) {
        var _this = this;
        _classCallCheck(this, LazyStore);
        _defineProperty(this, "_scrollToIndex", undefined);
        _defineProperty(this, "_maxSize", {
            isGuessed: true,
            height: 0
        });
        _defineProperty(this, "visibleItems", {
            spaceBefore: 0,
            spaceAfter: 0,
            items: [],
            sizes: [],
            indexesInViewport: []
        });
        _defineProperty(this, "_locked", 0);
        _defineProperty(this, "isMounted", false);
        _defineProperty(this, "items", []);
        _defineProperty(this, "scroller", (0, _mobx).observable({
            el: undefined,
            width: 0,
            height: 0,
            scrollTop: 0,
            scrollLeft: 0,
            scrollWidth: 0,
            scrollHeight: 0
        }));
        _defineProperty(this, "root", (0, _mobx).observable({
            el: undefined,
            top: 0,
            left: 0
        }));
        _defineProperty(this, "updateScrollPos", function() {
            var oldScroller = {
                scrollLeft: _this.scroller.scrollLeft,
                scrollTop: _this.scroller.scrollTop
            };
            var scrollTop = (0, _dom).default(_this.scroller.el).scrollTop();
            if (scrollTop < 0) scrollTop = 0;
            var scrollLeft = (0, _dom).default(_this.scroller.el).scrollLeft();
            if (scrollLeft < 0) scrollLeft = 0;
            _this.scroller.scrollTop = scrollTop;
            _this.scroller.scrollLeft = scrollLeft;
            _this.scroller.scrollWidth = (0, _dom).default(_this.scroller.el).scrollWidth();
            _this.scroller.scrollHeight = (0, _dom).default(_this.scroller.el).scrollHeight();
            if (_this.config.onScroll) _this.config.onScroll({
                width: _this.scroller.width,
                height: _this.scroller.height,
                top: _this.scroller.scrollTop,
                left: _this.scroller.scrollLeft,
                scrollWidth: _this.scroller.scrollWidth,
                scrollHeight: _this.scroller.scrollHeight
            });
            if (oldScroller.scrollLeft !== _this.scroller.scrollLeft || oldScroller.scrollTop !== _this.scroller.scrollTop) _this.updateVisibleItems();
        });
        (0, _mobx).makeObservable(this, {
            _maxSize: _mobx.observable,
            visibleItems: _mobx.observable,
            isMounted: _mobx.observable,
            items: _mobx.observable,
            mount: _mobx.action,
            updateScrollPos: _mobx.action,
            resize: _mobx.action,
            checkRootOffset: _mobx.action,
            setItems: _mobx.action,
            scrollToIndex: _mobx.action,
            scrollIntoView: _mobx.action,
            storeMaxSize: _mobx.action,
            updateVisibleItems: _mobx.action,
            setVisibleItems: _mobx.action
        });
        this.config = config;
        this.measureEl = null;
        this.initResizeObserver();
        if (this.config.initialScrollIndex !== undefined) this.scrollToIndex(this.config.initialScrollIndex);
        this._onScroll = (0, _throttleDebounce).throttle(25, this.updateScrollPos);
        this._onResize = (0, _throttleDebounce).throttle(25, this.resize.bind(this));
    }
    _createClass(LazyStore, [
        {
            key: "log",
            value: function log(msg) {
                if (!__DEV__) return;
                if (!this._log) this._log = [];
                this._log.push(msg);
            }
        },
        {
            key: "lock",
            value: function lock(state) {
                if (state === undefined) return this._locked !== 0;
                if (state) this._locked++;
                else {
                    this._locked--;
                    if (this._locked < 0) this._locked = 0;
                }
            }
        },
        {
            key: "initResizeObserver",
            value: function initResizeObserver() {
                var _this = this;
                if (isServerSide) return;
                // PonyFill resizeObserver if necessary
                var _resizeObserver1 = window.ResizeObserver ? window.ResizeObserver : _resizeObserver.ResizeObserver;
                this.resizeObserver = new _resizeObserver1(function(entries) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function(_iterator, _step) {
                            var entry = _step.value;
                            if (entry.contentRect.height !== _this.scroller.height || entry.contentRect.width !== _this.scroller.width) {
                                var _this1 = _this;
                                if (entry.contentRect.height === 0 || entry.contentRect.width === 0) return {
                                    v: void void 0
                                };
                                (0, _mobx).runInAction(function() {
                                    _this1.scroller.width = entry.contentRect.width;
                                    _this1.scroller.height = entry.contentRect.height;
                                });
                                _this.updateVisibleItems();
                            }
                        };
                        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _ret = _loop(_iterator, _step);
                            if (_typeof(_ret) === "object") return _ret.v;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        },
        {
            key: "mount",
            value: function mount(scrollerNode, rootNode, measureNode) {
                var _this = this;
                (0, _mobx).transaction(function() {
                    _this.scroller.el = scrollerNode;
                    _this.root.el = rootNode;
                    _this.measureEl = measureNode;
                    if (!isServerSide && __DEV__) {
                        var computedStyles = window.getComputedStyle(_this.root.el.parentNode);
                        if (computedStyles.getPropertyValue('position') === 'static') console.warn("LazyList mag niet in een parent zitten met position static.", _this.root.el.parentNode);
                    }
                    _this.scroller.el.addEventListener('scroll', _this._onScroll, {
                        passive: true
                    });
                    window.addEventListener('resize', _this._onResize);
                    window.addEventListener('orientationchange', _this._onOrientationChange);
                    if (_instanceof(_this.scroller.el, Element)) _this.resizeObserver.observe(_this.scroller.el);
                    _this.isMounted = true;
                    _this.updateScrollPos();
                    _this.resize();
                });
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                this.isMounted = false;
                if (this.scroller.el) this.scroller.el.removeEventListener('scroll', this._onScroll, {
                    passive: true
                });
                window.removeEventListener('resize', this._onResize);
                window.removeEventListener('orientationchange', this._onOrientationChange);
                if (this.resizeObserver) this.resizeObserver.disconnect();
            }
        },
        {
            key: "isVertical",
            get: function get() {
                return this.config.direction === 'vertical';
            }
        },
        {
            key: "getItemPos",
            value: function getItemPos(index) {
                if (!this.isMounted || this.items.length <= index) return undefined;
                // pos is y bij verticale lijsten, anders x
                var pos = 0;
                for(var a = 0; a < index && a < this.items.length; a++){
                    if (pos === undefined) pos = 0;
                    var layout = this.getItemLayout(this.items[a], a);
                    pos += layout.size + layout.before + layout.after;
                }
                return pos;
            }
        },
        {
            key: "scrollPos",
            get: function get() {
                var pos = this.isVertical ? this.scroller.scrollTop : this.scroller.scrollLeft;
                if (this._scrollToIndex !== undefined) {
                    var itemPos = this.getItemPos(this._scrollToIndex);
                    if (itemPos !== undefined) {
                        pos = itemPos;
                        var itemLayout = this.getItemLayout(this.items[this._scrollToIndex], this._scrollToIndex);
                        if (this._scrollToIndex > 0) {
                            pos -= this.isVertical ? this.scroller.height / 2 : this.scroller.width / 2;
                            pos += itemLayout.before;
                            pos += itemLayout.size / 2;
                            pos += this.config.viewportOffset.before / 2;
                            pos += this.config.viewportOffset.after / 2;
                        }
                    }
                    this.scrollTo(pos);
                }
                return pos;
            }
        },
        {
            key: "autoScrollIntoView",
            value: function autoScrollIntoView() {
                var _this = this;
                if (this._scrollToIndex !== undefined) requestAnimationFrame(function() {
                    if (!_this.isMounted) return;
                    var pos = _this.scrollPos;
                    _this._scrollToIndex = undefined;
                    _this.scrollTo(pos);
                });
            }
        },
        {
            key: "currentIndex",
            get: function get() {
                // welk item staat nu ongeveer in het midden van de scrollview?
                var scrollPos = this.isVertical ? this.scroller.scrollTop + this.scroller.height / 2 : this.scroller.scrollLeft + this.scroller.width / 2;
                if (this.scroller.scrollTop < 10 || !this.isMounted) return 0;
                var start = this.visibleItems.index;
                var end = start + this.visibleItems.items.length;
                var index = start;
                for(var a = start; a < end; a++){
                    var itemPos = this.getItemPos(a);
                    if (itemPos !== undefined) {
                        var itemLayout = this.getItemLayout(this.items[a], a);
                        var itemEnd = itemPos + itemLayout.before + itemLayout.size + itemLayout.after;
                        if (scrollPos >= itemPos && scrollPos <= itemEnd) {
                            index = a;
                            break;
                        }
                    }
                }
                return index;
            }
        },
        {
            key: "resize",
            value: function resize() {
                this.storeMaxSize(0, true, true);
                this.visibleItems.spaceAfter = 0;
                this.visibleItems.spaceBefore = 0;
                var scrollerSize = (0, _dom).default(this.scroller.el).layout();
                var rootSize = (0, _dom).default(this.root.el).layout();
                this.scroller.width = (0, _dom).default(this.measureEl).layout().width;
                this.scroller.height = scrollerSize.height;
                this.checkRootOffset();
                if (this.config.onResize) this.config.onResize(scrollerSize, rootSize);
                this.updateVisibleItems();
            }
        },
        {
            key: "checkRootOffset",
            value: function checkRootOffset() {
                if (!this.isMounted) return;
                // Vangt cases af waarbij er voor de lazylist ook nog andere elementen staan
                // die de positie van de lazylist binnen de scroller beinvloeden
                var rootOffset = getDocumentOffsetPosition(this.root.el);
                var scrollerOffset = getDocumentOffsetPosition(this.scroller.el);
                var top = rootOffset.top - scrollerOffset.top;
                var left = rootOffset.left - scrollerOffset.left;
                this.root.before = this.isVertical ? top : left;
            }
        },
        {
            key: "setItems",
            value: function setItems(items) {
                this.items.replace(items);
                this.lock(false);
                if (items.length > 0) this.checkRootOffset();
                this.updateVisibleItems();
                this._maxSize.isGuessed = true;
            }
        },
        {
            key: "getItemLayout",
            value: function getItemLayout(item, index) {
                if (!this.isMounted) return {
                    size: 0
                };
                var layout = this.config.getItemLayout(item, index);
                if (layout.constructor.name === "Promise") {
                    var _this = this;
                    layout.then(function() {
                        _this.updateVisibleItems();
                    });
                    return {
                        size: 0
                    };
                }
                if (!layout.hasOwnProperty('size')) console.error('getItemLayout expected object with property size');
                if (!layout.hasOwnProperty('after')) layout.after = 0;
                if (!layout.hasOwnProperty('before')) layout.before = 0;
                return layout;
            }
        },
        {
            key: "scrollToIndex",
            value: function scrollToIndex(index, animate) {
                this._scrollToIndex = index;
                var itemPos = this.getItemPos(this._scrollToIndex);
                if (itemPos !== undefined) {
                    this._scrollToIndex = undefined;
                    var itemLayout = this.getItemLayout(this.items[index], index);
                    // Centreer in de view
                    var extraSize = itemLayout.size / 2;
                    extraSize -= this.isVertical ? this.scroller.height / 2 : this.scroller.width / 2;
                    this.scrollTo(itemPos + this.root.before + extraSize, animate);
                }
            }
        },
        {
            key: "scrollIntoView",
            value: function scrollIntoView(index) {
                var myConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (!this.isMounted) return;
                var config = _objectSpread({
                    before: 0,
                    after: 0
                }, myConfig);
                var item = this.items[index];
                var itemLayout = (0, _mobx).toJS(this.getItemLayout(item, index));
                var scrollSize = this.isVertical ? this.scroller.height : this.scroller.width;
                var itemPos = this.getItemPos(index);
                var topPos = this.root.before + config.before;
                var bottomPos = topPos + scrollSize - config.after;
                var scrollPos = this.isVertical ? Math.round(this.scroller.scrollTop) : Math.round(this.scroller.scrollLeft);
                var topInView = itemPos - scrollPos > topPos && itemPos - scrollPos < bottomPos;
                var bottomInView = itemPos - scrollPos + itemLayout.size > topPos && itemPos - scrollPos + itemLayout.size < bottomPos;
                if (topInView || bottomInView) return;
                else this.scrollToIndex(index, false);
            }
        },
        {
            key: "scrollTo",
            value: function scrollTo(pos, animate) {
                var _this = this;
                var skipScroll = this.isVertical ? Math.round(this.scroller.scrollTop) === Math.round(pos) : Math.round(this.scroller.scrollLeft) === Math.round(pos);
                if (skipScroll) return Promise.resolve();
                return new Promise(function(resolve) {
                    var _this2 = _this;
                    _this.lock(true);
                    (0, _dom).default(_this.scroller.el).scrollTo(Math.round(pos), animate, _this.config.direction).then(function() {
                        _this2.lock(false);
                        resolve();
                    });
                });
            }
        },
        {
            key: "storeMaxSize",
            value: function storeMaxSize(size) {
                var isGuessed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, force = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (force) {
                    this._maxSize.isGuessed = true;
                    this._maxSize.size = size;
                    return;
                }
                if (isGuessed) {
                    if (this._maxSize.isGuessed) this._maxSize.size = Math.max(this._maxSize.size, size);
                } else {
                    this._maxSize.isGuessed = false;
                    this._maxSize.size = size;
                }
            }
        },
        {
            key: "onEndReached",
            value: function onEndReached() {
                if (this._endReached === this.items.length) return;
                if (this.config.onEndReached !== undefined) {
                    var _this = this;
                    this._endReached = this.items.length;
                    this.config.onEndReached().then(function() {
                        if (_this.isMounted) _this.updateVisibleItems();
                    });
                }
            }
        },
        {
            key: "setVisibleItems",
            value: function setVisibleItems(items) {
                this.visibleItems = {
                    spaceBefore: 0,
                    spaceAfter: 0,
                    index: 0,
                    items: items,
                    sizes: {},
                    indexesInViewport: []
                };
            }
        },
        {
            key: "updateVisibleItems",
            value: function updateVisibleItems() {
                if (!this.isMounted) return;
                if (this.lock()) // skip updateVisibleItems want locked
                return;
                this.lock(true);
                var returnValue = {
                    index: 0,
                    spaceBefore: 0,
                    spaceAfter: 0,
                    items: [],
                    skippedItems: [],
                    indexesInViewport: []
                };
                if (this.isMounted) {
                    if (this.items.length === 0) {
                        if (this._scrollToIndex !== undefined) this.scrollTo(this.root.before);
                    } else {
                        var windowSizeLeft = Math.max(0, this.config.windowSize - 1);
                        var windowSizeAfter = Math.max(0, Math.ceil(windowSizeLeft / 2));
                        var windowSizeBefore = Math.max(0, windowSizeLeft - windowSizeAfter);
                        var scrollPos = this.scrollPos - this.root.before;
                        var scrollerSize = this.isVertical ? this.scroller.height : this.scroller.width;
                        var viewportStart = scrollPos + this.config.viewportOffset.before;
                        var viewportEnd = scrollPos + scrollerSize - this.config.viewportOffset.after;
                        var start = scrollPos - windowSizeBefore * scrollerSize;
                        var end = scrollPos + (scrollerSize + windowSizeAfter * scrollerSize);
                        //genoeg items en mounted this.items.length
                        var startIndex = 0;
                        var endIndex = 0;
                        var startPos = 0;
                        var pos = 0;
                        var visibleItems = [];
                        var visibleItemSizes = [];
                        var indexesInViewport = [];
                        var visibleSize = 0;
                        for(var index = 0; index < this.items.length; index++){
                            var item = this.items[index];
                            var layout = (0, _mobx).toJS(this.getItemLayout(item, index));
                            var itemSize = layout.size + layout.before + layout.after;
                            var itemStart = pos;
                            var itemEnd = pos + itemSize;
                            pos += itemSize;
                            if (layout.size === 0) {
                                // retry
                                this.lock(false);
                                return;
                            }
                            var isVisible = itemStart <= start && itemEnd > start || itemStart >= start && itemStart < end;
                            var isInViewport = itemStart <= viewportStart && itemEnd > viewportStart || itemStart >= viewportStart && itemStart < viewportEnd;
                            if (!isVisible) {
                                if (visibleItems.length > 0) break;
                                if (index === this.items.length - 1) {
                                    this.onEndReached();
                                    break;
                                }
                                continue;
                            }
                            visibleSize += itemSize;
                            if (visibleItems.length === 0) {
                                startPos = itemStart;
                                startIndex = index;
                            }
                            endIndex = index;
                            visibleItems.push(item);
                            visibleItemSizes.push(layout.size);
                            if (isInViewport) indexesInViewport.push(index);
                        }
                        returnValue.spaceBefore = startPos;
                        returnValue.spaceAfter = Math.max(0, this._maxSize.size - startPos - visibleSize);
                        returnValue.index = startIndex;
                        returnValue.items = visibleItems;
                        returnValue.sizes = visibleItemSizes;
                        returnValue.indexesInViewport = indexesInViewport;
                        if (this.items.length > endIndex + 1) this.storeMaxSize(pos + scrollerSize, true);
                        else // Einde bereikt, we weten de max height nu zeker
                        this.storeMaxSize(pos);
                        var endReached = endIndex === this.items.length - 1;
                        if (endReached) this.onEndReached();
                        this.autoScrollIntoView();
                    }
                }
                this.visibleItems = returnValue;
                this.lock(false);
            }
        }
    ]);
    return LazyStore;
}();
var _default = LazyStore;
exports.default = _default;
